import EventViewActions from './EventViewActions';

export default EventViewActions;
